import { apiRequest } from "@/lib/queryClient";

/** An opaque transaction identifier is not an identity or an authorization grant. */
export function embedTransaction(search: string): string | null {
  const id = new URLSearchParams(search).get("embed_transaction");
  return id && /^[a-zA-Z0-9_-]{20,128}$/.test(id) ? id : null;
}

export async function completeEmbedLogin(transactionId: string): Promise<void> {
  // apiRequest reads the actual session token, including Remember Me=false.
  // The server reauthorizes the transaction's target bot before completing it.
  await apiRequest("POST", `/sso/embed/complete/${encodeURIComponent(transactionId)}`, {});
  window.location.replace(`/sso/embed/completion/${encodeURIComponent(transactionId)}`);
}
